import firestore from "../../../firebase/firestore";
import {
  getBalancebyRecipient,
  getRecipient,
  getBalanceOperations,
  createTransfers,
} from "../../../services/pagarmeLib";

export default {
  resetFilter({ commit }) {
    commit("resetState");
  },
  getBalance({ commit }, recipient_id) {
    commit("setLoading", true);
    // console.log('recipient_id: ', recipient_id)
    return getBalancebyRecipient(recipient_id)
      .then((balance) => {
        // console.log('balance: ', balance)
        commit("setLoading", false);
        commit("setBalance", balance);
        return balance;
      })
      .catch((error) => {
        commit("setBalance", []);
        commit("setLoading", false);
        console.error(error);
        return error;
      });
  },
  getBalanceItems({ commit }, params) {
    commit("setLoading", true);
    // console.log('params: ', params)
    // console.log('recipient_id: ', params.recipient_id)
    // console.log('startDate1: ', params.startDate)
    // console.log('endDate: ', params.endDate)
    return getBalanceOperations(
      params.recipient_id,
      params.startDate,
      params.endDate,
      null,
    )
      .then((balanceOperations) => {
        // console.log('balanceOperations: ', balanceOperations)
        commit("setLoading", false);
        commit("setBalanceOperations", balanceOperations);
        return balanceOperations.reverse();
      })
      .catch((error) => {
        commit("setBalanceOperations", []);
        commit("setLoading", false);
        console.error(error);
        return error;
      });
  },
  exportBalanceItems({ commit }, params) {
    commit("setLoading", true);
    // console.log('params: ', params)
    // console.log('recipient_id: ', params.recipient_id)
    // console.log('startDate1: ', params.startDate)
    // console.log('endDate: ', params.endDate)
    return getBalanceOperations(
      params.recipient_id,
      params.startDate,
      params.endDate,
      params.format,
    )
      .then((balanceOperations) => {
        // console.log('balanceOperations: ', balanceOperations)
        commit("setLoading", false);
        // console.log('export balanceOperations: ')
        // commit('setBalanceOperations', balanceOperations)
        if (balanceOperations) return balanceOperations;
        else return;
      })
      .catch((error) => {
        // commit('setBalanceOperations', [])
        commit("setLoading", false);
        console.error(error);
        return error;
      });
  },
  getPartners({ commit }, params) {
    try {
      commit("setLoading", true);
      // console.log('params: ', params)
      if (params) {
        let partnersRef = firestore.collection("partners");
        if (params.partners !== "all" && params.partners) {
          partnersRef.where("id", "in", params.partners);
        }
        return partnersRef
          .get()
          .then((partners) => {
            // .onSnapshot({ includeMetadataChanges: true }, async partners => {
            // const changes = res.docChanges();
            if (partners.size > 0) {
              let _partners = partners.docs.map((partner) => {
                return { id: partner.id, ...partner.data() };
              });
              // console.log('partners', _partners)
              commit("setPartners", _partners);
              // this.getConsumerUnitsByUser({commit}, users.docs[0].id)
            } else {
              // console.log('setUserNotFound', users)
              commit("setPartners", []);
              // console.log('us: ', users)
            }
            commit("setLoading", false);
          })
          .catch((err) => {
            commit("setPartner", []);
            console.error(err);
            commit("setLoading", false);
          });
      }
    } catch (err) {
      commit("setPartners", []);
      console.error(err);
      commit("setLoading", false);
    }
  },
  async getBankAccounts({ commit }, recipients) {
    try {
      commit("setLoading", true);
      let bankAccounts = [];
      // console.log('params: ', recipients)
      if (recipients && recipients.length > 0) {
        for (var i = 0; i < recipients.length; i++) {
          await getRecipient(recipients[i])
            .then((bankAccount) => {
              // console.log('bankAccount: ', bankAccount)
              bankAccounts.push(bankAccount);
            })
            .catch((error) => {
              console.error(error);
            });
        }
        commit("setLoading", false);
        commit("setBankAccounts", bankAccounts);
        return bankAccounts;
      } else {
        commit("setLoading", false);
        commit("setBankAccounts", []);
        return bankAccounts;
      }
    } catch (err) {
      commit("setPartners", []);
      console.error(err);
      commit("setLoading", false);
    }
  },
  createTransfer({ commit, dispatch }, params) {
    commit("setLoading", true);
    if (!params.amount || params.amount <= 3.67)
      return { error: "O saque deve ser maior que R$ 3,67" };
    if (!params.recipient_id)
      return { error: "Conta do recebedor não informada" };
    // console.log('recipient_id: ', recipient_id)
    return createTransfers(params.recipient_id, params.amount)
      .then((transfer) => {
        // console.log('balance: ', balance)
        // commit('setLoading', false)
        dispatch("getBalanceItems", params);
        // commit('setBalance', balance)
        return transfer;
      })
      .catch((error) => {
        // commit('setBalance', [])
        // commit('setLoading', false)
        console.error(error);
        return error;
      });
  },
};
